import { copyToTheClipboard } from "../../common/utils";
export const getMessageContent = (message) => typeof message.content === "string"
    ? message.content
    : message.content.message;
export const getMessageSerializedContentAll = (message) => typeof message.content === "string"
    ? message.content
    : JSON.stringify(message.content, undefined, 2);
export const getMessageFiles = (message) => typeof message.content === "object" ? message.content.files ?? [] : [];
export const getMessageSources = (message) => typeof message.content === "object" ? message.content.sources ?? [] : [];
export const getMessageFilesAndSources = (message) => typeof message.content === "object"
    ? {
        files: message.content.files ?? [],
        sources: message.content.sources ?? []
    }
    : { files: [], sources: [] };
export const DEFAULT_ASSISTANT_STATUS = "complete";
export const DEFAULT_FILE_UPLOAD_STATE = "uploaded";
export const copy = (text) => () => copyToTheClipboard(text);
